import React from "react";
import certificateWeb from '../../../static/img/Certificate/Certificate.png';
import './Certificate.css';
import gql from "graphql-tag";
import LayoutMain from "../../../Elements/LayoutMain/LayoutMain";
import IfYouHaveQuestions from "../../../Elements/LayoutMain/IfYouHaveQuestions/IfYouHaveQuestions";
import QueryAllCertificates from "./QueryAllCertificates/QueryAllCertificates";
import TextChange from "../../../../AdminPart/src/Elements/TextChange/TextChange";



function GatsbyCertificateSource (props) {
        function TextSource(info) {let InText = '*undefined';if (props.Adminka) {try {InText = JSON.parse(props.AllInformation[info.ArrIndex])[props.lang] ? JSON.parse(props.AllInformation[info.ArrIndex])[props.lang] : '*'+info.children}   catch (err) {InText = '*'+info.children}return <TextChange update={props.updateData} Text={InText} ArrIndex={info.ArrIndex} lang={props.lang} Adminka={true}/>
        } else {try {return <>{JSON.parse(props.PrerenderTexts[info.ArrIndex])[props.lang] ? JSON.parse(props.PrerenderTexts[info.ArrIndex])[props.lang] : '*'+info.children}</>}   catch (err) {return <>*{info.children}</>}}}

        return (
    <LayoutMain title={props.title} description={props.description} lang={props.lang} AllMenu={['ElementMenuActive','','','','','']} Active={0}>
    <div className="Certificate">
        <div className="StandartPage">
            <div className="StandartInZeroBig">
                <div className="StandartTitleOut StandartTitleTop">
                    <div className="StandartTitle"><TextSource ArrIndex= 'Certificate0015'>Certificate</TextSource> </div>
                    <IfYouHaveQuestions lang={props.lang}/>
                </div>
        <div className="CertificateIMGWeb"><img alt='alt' src={certificateWeb}/></div>
                <QueryAllCertificates lang={props.lang}/>

    </div>
    </div>
    </div>
    </LayoutMain>
)}

export default GatsbyCertificateSource